import React, { useCallback, useMemo } from 'react'
import { SyncOutlined, TagsOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { DISH_DRAWER_TYPES } from '../../constants'
import { useDishSuggestCurationAndUpdate } from '../../hooks'
import { dishPropType } from '../../prop-types'

import DishDrawerButton from './dish-drawer-button'

const DishActionsCell = ({ dish, isDisabled }) => {
  const [suggestAndUpdate] = useDishSuggestCurationAndUpdate(dish.id)

  const handleSuggestCuration = useCallback(
    () => suggestAndUpdate(),
    [suggestAndUpdate],
  )

  const handleSuggestLabelAndIngredients = useCallback(
    () =>
      suggestAndUpdate({
        shouldSuggestOnlyLabelsAndIngredients: true,
      }),
    [suggestAndUpdate],
  )

  const isRetryDisabled = useMemo(
    () => isDisabled || dish.isAiIgnored || dish.isManualIgnored,
    [dish.isAiIgnored, dish.isManualIgnored, isDisabled],
  )

  return (
    <>
      <DishDrawerButton
        dishId={dish.id}
        drawerType={DISH_DRAWER_TYPES.DISH_DETAILS}
      />
      <Tooltip placement="topLeft" title="Retry curation">
        <Button
          disabled={isRetryDisabled}
          icon={<SyncOutlined />}
          shape="circle"
          onClick={handleSuggestCuration}
        />
      </Tooltip>
      <Tooltip placement="topLeft" title="Retry Labels & Ingredients">
        <Button
          disabled={isRetryDisabled}
          icon={<TagsOutlined />}
          shape="circle"
          onClick={handleSuggestLabelAndIngredients}
        />
      </Tooltip>
    </>
  )
}

DishActionsCell.propTypes = {
  dish: dishPropType.isRequired,
  isDisabled: PropTypes.bool,
}

DishActionsCell.defaultProps = {
  isDisabled: false,
}

export default DishActionsCell
